import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate';
import zh_CN from 'vee-validate/dist/locale/zh_CN'
//import VueI18n from 'vue-i18n';
//
//Vue.use(VueI18n)
//const i18n = new VueI18n({
//  locale: 'zh_CN',
//})
//
//Vue.use(VeeValidate, {
//  i18n,
//  i18nRootKey: 'validation',
//  dictionary: {
//      zh_CN
//  }
//});


// 配置中文
//Validator.addLocale(zh_CN);
//Validator.localize('zh_CN', zh_CN);

const config = {
 	locale: 'zh_CN',
// 	events: 'input|change',   //默认input 事件
  	dictionary : {
	   	zh_CN: {
	      	messages: {
		        email: () => '请输入正确的邮箱格式',
		        required: ( field )=> "请输入" + field,
		        url: () => '请输入正确的url格式',
	      	},
	      	attributes:{
		        email:'邮箱',
		        password:'密码',
	      	}
	  	}
	}
};

Vue.use(VeeValidate,config);


//自定义规则
import {isMobile} from './modules/demoValidat.js';
import { checkNum, checkNum2} from './modules/bpm.js';


//加入验证器
Validator.extend('isMobile', isMobile);
Validator.extend('checkNum', checkNum);
Validator.extend('checkNum2', checkNum2);





// WEBPACK FOOTER //
// ./src/validator/validate.js